import { memo } from "react";

import { StyledSection, StyledSectionTitle } from "./styles";
import SubSectionRenderer from "./SubSectionRenderer";
import type { Section, Translator } from "./types";

interface SectionRendererProps {
  section: Section;
  translator: Translator;
}

function SectionRenderer({
  section,
  translator,
}: Readonly<SectionRendererProps>) {
  return (
    <StyledSection>
      <StyledSectionTitle variant='title2'>{`${translator.with(section)}`}</StyledSectionTitle>

      {section.subSections
        .filter((subSection) => subSection.mustBeDisplayed())
        .map((subSection) => (
          <SubSectionRenderer
            key={`sub-section-${subSection.number}`}
            subSection={subSection}
            translator={translator}
          />
        ))}
    </StyledSection>
  );
}

export default memo(SectionRenderer);
